<template>
    <el-form :model="servcWorkVoucher" class="demo-ruleForm">
        <div class="block-container">
            <template v-if="dbServcWorkVoucher.deviceFlag">
                <div class="content-caption dashed bg-white">
                    <span>设备信息</span>
                </div>
                <div class="simple-form">
                    <div class="form-group center">
                        <div class="form-label">
                            <label>设备名称</label>
                        </div>
                        <div class="form-value">
                            <span>{{dbServcWorkVoucher.devcTitle}}</span>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>设备分类</label>
                        </div>
                        <div class="form-value">
                            <span>{{dbServcWorkVoucher.devcCatName}}</span>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>设备品牌</label>
                        </div>
                        <div class="form-value">
                            <span>{{dbServcWorkVoucher.deviceBrandName}}</span>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>设备编号</label>
                        </div>
                        <div class="form-value">
                            <span>{{dbServcWorkVoucher.tmpNo}}</span>
                        </div>
                    </div>
                </div>

            </template>
            <template v-if="servcWorkVoucher.comnRepairFlag">
                <div class="content-caption dashed bg-white">
                    <span>服务项目</span>
                </div>
                <div class="simple-form">
                    <div class="form-group center">
                        <div class="form-label ">
                            <label class="required">服务项目</label>
                        </div>
                        <div class="form-value">
                            <span>{{servcWorkVoucher.comnRepairTitle}}</span>
                        </div>
                    </div>
                </div>
            </template>
            <div class="content-caption dashed">
                <span>服务商</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">服务商</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="servicerName">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="servcWorkVoucher.servicerName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectServicer"></i>
                        </el-form-item>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed bg-white">
                <span>服务信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>服务类型</label>
                    </div>
                    <div class="form-value">
                        <span>{{workServcTypeMap[dbServcWorkVoucher.servcType]}}</span>
                    </div>
                </div>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>紧急状态</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-select placeholder="请选择" v-model="servcWorkVoucher.emgLevel">
                            <el-option v-for="emgLevel in emgLevelList" :key="emgLevel.value" :label="emgLevel.text" :value="emgLevel.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label ">
                        <label class="required">服务</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x bottom-line" :disabled="true" v-model="servcWorkVoucher.servcTitle"></el-input>
                        <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectServc"></i>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>其他信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center" v-if="showBasicClaim">
                    <div class="form-label">
                        <label>价格质量要求</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-select placeholder="请选择" v-model="basicClaimIndex" @change="selectBasicClaim">
                            <el-option v-for="(basicClaim, index) in servcBasicClaimList" :key="basicClaim.id" :label="basicClaim.goodsModel" :value="index"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">上门费</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.toDoorFee"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">服务费</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.generallFee"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">要求响应时长</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.yqRspTimeMi"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">要求到达时长</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.yqArriveTimeMi" @change="yqArriveTimeMiChange"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">要求完成时长</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" v-model="servcWorkVoucher.yqRepairedTimeMi"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">要求回询时限</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-2x" min="0" v-model="servcWorkVoucher.reqTelCallTimeMi"></el-input>
                        <span>分钟</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">预约时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-date-picker class="width-2x" :clearable=false v-model="servcWorkVoucher.planTime" type="datetime" placeholder="选择预约时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">情况描述</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input type="textarea" v-model="servcWorkVoucher.troubleDesc"></el-input>
                    </div>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv'
    import userApi from '../../api/user'
    import goodsDelivApi from '../../api/goodsDeliv'
    import shopDevcApi from '../../api/shopDevc'
    import servcClaimApi from '../../api/servcClaim'

    import { openServcDlg } from '../servc/selectDlg'
    import { openServicerSelectComnDlg } from './showDetailDlg'

    export default{
        name: 'swb-servc-work-voucher-copy-save',
        desc: '复制工单',
        props: {
            voucherId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                dbServcWorkVoucher: {
                    deviceFlag: false
                },
                servcWorkVoucher: {
                    yqRspTimeMi: 30,
                    yqArriveTimeMi: 60,
                    yqRepairedTimeMi: 120,
                    reqTelCallTimeMi: 0,
                    toDoorFee: null,
                    generallFee: null,
                    troubleDesc: '',
                    emgLevel: 0,
                    planTime: null
                },
                emgLevelList: getEnumList("emgLevel", 'value2text'),
                workServcTypeMap: {},
                servcBasicClaimList: [],
                showBasicClaim: false,
                basicClaimIndex: 0
            }
        },
        created: function () {
            let dateNow = new Date();
            let planTime = dateNow.setTime(dateNow.getTime() + this.servcWorkVoucher.yqArriveTimeMi * 60 * 1000);
            this.servcWorkVoucher.planTime = planTime;
            this.workServcTypeMap = getEnumMap('workServcType', 'value2text');
            this.getServcWorkVoucher();
        },
        methods: {
            getServcWorkVoucher(){
                let self = this;
                let params = {};
                params.id = self.voucherId;
                let theLoad = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherDetail(params, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.dbServcWorkVoucher = result.data;
                        self.handleVoucher();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleVoucher(){
                let dbVoucher = this.dbServcWorkVoucher;
                let servcWorkVoucher = this.servcWorkVoucher;
                //
                servcWorkVoucher.id = dbVoucher.id;
                servcWorkVoucher.buyerShopId = dbVoucher.buyerShopId;
                servcWorkVoucher.devcDefId = dbVoucher.devcDefId;
                servcWorkVoucher.comnRepairFlag = dbVoucher.comnRepairFlag;
                servcWorkVoucher.comnRepairId = dbVoucher.comnRepairId;
                servcWorkVoucher.comnRepairTitle = dbVoucher.comnRepairTitle;
                servcWorkVoucher.tmpNo = dbVoucher.tmpNo;
                servcWorkVoucher.devcCatId = dbVoucher.devcCatId;
                servcWorkVoucher.emgLevel = dbVoucher.emgLevel;
                servcWorkVoucher.troubleDesc = dbVoucher.troubleDesc;
                //
                servcWorkVoucher.servicerId = dbVoucher.servicerId;
                servcWorkVoucher.servicerName = dbVoucher.servicerName;
                //
                servcWorkVoucher.servcType = dbVoucher.servcType;
                servcWorkVoucher.ssuId = dbVoucher.ssuId;
                servcWorkVoucher.servcId = dbVoucher.servcId;
                servcWorkVoucher.servcCatId = dbVoucher.servcCatId;
                servcWorkVoucher.servcTitle = dbVoucher.servcTitle;
                //
                this.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                this.basicClaimIndex = null;
                this.renderServcInfo(dbVoucher.yqRspTimeMi, dbVoucher.yqArriveTimeMi, dbVoucher.yqRepairedTimeMi, dbVoucher.toDoorFee, dbVoucher.generallFee, true);
            },
            selectServicer(){
                let self = this;
                let servcWorkVoucher = this.servcWorkVoucher;
                let params = {
                    showBizRel: true
                };
                if(!Utils.isNoB(servcWorkVoucher.tmpNo)) {
                    params.showDevice = true;
                    params.showDevcgroup = true;
                    params.servcType = servcWorkVoucher.servcType;
                    params.retailerComId = servcWorkVoucher.buyerShopId;
                    params.devcDefId = servcWorkVoucher.devcDefId;
                    this.toServicerSelect(params);
                } else if(servcWorkVoucher.comnRepairFlag && servcWorkVoucher.comnRepairId != null) {
                    params.showComnRepair = true;
                    params.repairId = servcWorkVoucher.comnRepairId;
                    this.toServicerSelect(params);
                } else {
                    this.toServicerSelect(params);
                }
            },
            toServicerSelect(params){
                let self = this;
                let servcWorkVoucher = this.servcWorkVoucher;
                openServicerSelectComnDlg(params, function (servicer) {
                    servcWorkVoucher.servicerId = servicer.servicerId;
                    servcWorkVoucher.servicerName = servicer.servicerName;
                    // 清除服务信息
                    servcWorkVoucher.ssuId = null;
                    servcWorkVoucher.servcId = null;
                    servcWorkVoucher.servcTitle = null;
                    servcWorkVoucher.servcCatId = null;
                    //
                    self.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                    self.renderServcInfo(null, null, null, null, null, true);
                });
            },
            selectServc: function () {
                let self = this;
                let servcWorkVoucher = self.servcWorkVoucher;
                let merchantId = servcWorkVoucher.goodsSellerId;
                let merchantType = servcWorkVoucher.goodsSellerType;
                if(Utils.isNoB(servcWorkVoucher.servicerId)) {
                    this.$message.warning('请选择服务商');
                    return;
                }
                let params = {
                    merchantId: servcWorkVoucher.servicerId,
                    merchantType: 4,
                    type: servcWorkVoucher.servcType,
                    checkBox: false
                };
                openServcDlg(params, function (result) {
                    servcWorkVoucher.ssuId = result.ssuId;
                    servcWorkVoucher.servcId = result.servcId;
                    servcWorkVoucher.servcTitle = result.title;
                    //
                    self.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                    self.renderServcInfo(result.rspTimeMi, result.arriveTimeMi, result.repairedTimeMi, result.toDoorFee, result.generallFee, true);
                });
            },
            yqArriveTimeMiChange(){
                let servcWorkVoucher = this.servcWorkVoucher;
                let yqArriveTimeMi = servcWorkVoucher.yqArriveTimeMi;
                if(!Utils.isNoB(yqArriveTimeMi) && Utils.isNaturalStr(yqArriveTimeMi, true)) {
                    let dateNow = new Date();
                    let planTime = dateNow.setTime(dateNow.getTime() + yqArriveTimeMi * 60 * 1000);
                    servcWorkVoucher.planTime = planTime;
                    this.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                }
            },
            handleReqVoucher(){
                let dbVoucher = this.dbServcWorkVoucher;
                let voucher = this.servcWorkVoucher;
                // 组装数据
                let servcReqVoucher = {};
                servcReqVoucher.workVoucherId = voucher.id;
                servcReqVoucher.buyerShopId = voucher.buyerShopId;
                servcReqVoucher.buyerComId = voucher.buyerComId;
                servcReqVoucher.emgLevel = voucher.emgLevel;
                servcReqVoucher.ssuId = voucher.ssuId;
                servcReqVoucher.servcId = voucher.servcId;
                servcReqVoucher.title = voucher.servcTitle;
                servcReqVoucher.requestDesc = dbVoucher.requestDesc;
                servcReqVoucher.troubleDesc = voucher.troubleDesc;
                servcReqVoucher.yqRspTimeMi = voucher.yqRspTimeMi;
                servcReqVoucher.yqArriveTimeMi = voucher.yqArriveTimeMi;
                servcReqVoucher.yqRepairedTimeMi = voucher.yqRepairedTimeMi;
                servcReqVoucher.toDoorFee = voucher.toDoorFee;
                servcReqVoucher.generallFee = voucher.generallFee;
                servcReqVoucher.tmpNo = voucher.tmpNo;
                servcReqVoucher.dstServicerId = voucher.servicerId;
                servcReqVoucher.grabFlag = false;
                return servcReqVoucher;
            },
            getDlgResult(){
                let dbVoucher = this.dbServcWorkVoucher;
                let servcWorkVoucher = this.servcWorkVoucher;
                if(Utils.isNoB(servcWorkVoucher.servicerId)) {
                    this.$message.warning('请选择服务商');
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.ssuId)) {
                    this.$message.warning('请选择服务');
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.toDoorFee) || !Utils.isMoneyStr(servcWorkVoucher.toDoorFee)) {
                    this.$message.warning("请正确填写上门费！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.generallFee) || !Utils.isMoneyStr(servcWorkVoucher.generallFee)) {
                    this.$message.warning("请正确填写服务费！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.yqRspTimeMi)) {
                    this.$message.warning("请填写要求响应时长！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.yqArriveTimeMi)) {
                    this.$message.warning("请填写要求到达时长！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.yqRepairedTimeMi)) {
                    this.$message.warning("请填写要求完成时长！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.reqTelCallTimeMi)) {
                    this.$message.warning("请填写要求回询时限！");
                    return null;
                }
                if(Utils.isNoB(servcWorkVoucher.planTime)) {
                    this.$message.warning("预约时间不能为空！");
                    return null;
                } else {
                    servcWorkVoucher.planTime = new Date(servcWorkVoucher.planTime).format('yyyy-MM-dd HH:mm');
                }
                if(Utils.isNoB(servcWorkVoucher.troubleDesc)) {
                    this.$message.warning("情况描述不可为空！");
                    return null;
                }
                if(dbVoucher.deviceFlag && dbVoucher.servcType == 0) {
                    let servcReqVoucher = this.handleReqVoucher();
                    if(this.servcBasicClaimList != null && this.servcBasicClaimList.length > 0 && this.basicClaimIndex != null && this.basicClaimIndex >= 0) {
                        servcReqVoucher.refBasicClaimId = this.servcBasicClaimList[this.basicClaimIndex].id;
                    }
                    return servcReqVoucher;
                } else {
                    if(this.servcBasicClaimList != null && this.servcBasicClaimList.length > 0 && this.basicClaimIndex != null && this.basicClaimIndex >= 0) {
                        servcWorkVoucher.refBasicClaimId = this.servcBasicClaimList[this.basicClaimIndex].id;
                    }
                    return servcWorkVoucher;
                }
            },
            renderServcInfo(rspTimeMi, arriveTimeMi, repairedTimeMi, toDoorFee, generallFee, queryFlag){
                let self = this;
                let servcWorkVoucher = self.servcWorkVoucher;
                this.getBasicClaimByAppliedShop(queryFlag, function (servcBasicClaimList) {
                    let reqTelCallTimeMi = servcWorkVoucher.reqTelCallTimeMi;
                    if(servcBasicClaimList != null && servcBasicClaimList.length > 0) {
                        if(servcBasicClaimList.length > 1 || self.basicClaimIndex == null) {
                            self.showBasicClaim = true;
                        }
                        ;
                        if(self.basicClaimIndex != null) {
                            let basicClaim = servcBasicClaimList[self.basicClaimIndex];
                            rspTimeMi = basicClaim.rspTimeMi;
                            arriveTimeMi = basicClaim.arriveTimeMi;
                            repairedTimeMi = basicClaim.repairedTimeMi;
                            toDoorFee = basicClaim.toDoorFee;
                            generallFee = basicClaim.generallFee;
                            reqTelCallTimeMi = basicClaim.telCallTimeMi;
                        }
                    } else {
                        self.showBasicClaim = false;
                    }
                    servcWorkVoucher.yqRspTimeMi = rspTimeMi;
                    servcWorkVoucher.yqArriveTimeMi = arriveTimeMi;
                    servcWorkVoucher.yqRepairedTimeMi = repairedTimeMi;
                    servcWorkVoucher.toDoorFee = toDoorFee;
                    servcWorkVoucher.generallFee = generallFee;
                    servcWorkVoucher.reqTelCallTimeMi = reqTelCallTimeMi;
                    //
                    let yqArriveTimeMi = servcWorkVoucher.yqArriveTimeMi;
                    if(!Utils.isNoB(yqArriveTimeMi) && Utils.isNaturalStr(yqArriveTimeMi, true)) {
                        let dateNow = new Date();
                        let planTime = dateNow.setTime(dateNow.getTime() + yqArriveTimeMi * 60 * 1000);
                        servcWorkVoucher.planTime = planTime;
                    }
                    self.servcWorkVoucher = Utils.merge({}, servcWorkVoucher);
                });
            },
            getBasicClaimByAppliedShop(queryFlag, callback){
                let self = this;
                let servcWorkVoucher = this.servcWorkVoucher;
                if(queryFlag) {
                    let postData = {};
                    postData.servcTypeId = servcWorkVoucher.servcType;
                    postData.appliedShopId = servcWorkVoucher.buyerShopId;
                    if(!Utils.isNoB(servcWorkVoucher.devcCatId)) {
                        postData.goodsCatId = servcWorkVoucher.devcCatId;
                    } else {
                        postData.servcCatId = servcWorkVoucher.servcCatId;
                    }
                    let loading = MsgBox.loading();
                    servcClaimApi.getServcBasicClaimByAppliedShop(postData, function (result) {
                        loading.close();
                        if(result.type === "info") {
                            self.servcBasicClaimList = result.data;
                            callback(result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    callback(this.servcBasicClaimList);
                }
            },
            selectBasicClaim(){
                this.renderServcInfo(null, null, null, null, null, false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherCopySave.vue